import { Deal } from '../types/deal';
import { getLocale } from '../i18n';

/**
 * Returns the deal with its runner-facing copy (message, headline, CTA label,
 * callout title/body) swapped to the active locale's translation when present.
 * Falls back to the default fields for any missing translation, so deals
 * without a `translations` map are returned unchanged. Non-text fields are
 * untouched.
 *
 * `description` is deliberately absent: it is an internal admin field
 * (required on every deal, authored beside the entitlement ID rather than in
 * the promo editor) and is no longer rendered to runners.
 */
export const localizeDeal = (deal: Deal | null | undefined): Deal | null | undefined => {
  if (!deal) return deal;
  const tr = deal.translations?.[getLocale()];
  if (!tr) return deal;

  const localized: Deal = {
    ...deal,
    message: tr.message || deal.message,
    headline: tr.headline || deal.headline,
    ctaText: tr.ctaText || deal.ctaText,
  };

  if (deal.callout && (tr.calloutTitle || tr.calloutBody)) {
    localized.callout = {
      ...deal.callout,
      title: tr.calloutTitle || deal.callout.title,
      body: tr.calloutBody || deal.callout.body,
    };
  }

  return localized;
};
